import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://2c1d9073e5b5b791cfe462378c417394@o4509563257552896.ingest.us.sentry.io/4509585055088640",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: "production",
  sendDefaultPii: true
});